export default "__VITE_ASSET__1uMJ40rr__"